import type { Rating } from "../lib/types";

export function Pips({ level }: { level: number }) {
  return <div className="pips" aria-hidden="true">
    {Array.from({ length: 10 }, (_, i) => <span key={i} className={"pip" + (level >= i + 1 ? " on" : level >= i + 0.5 ? " half" : "")} />)}
  </div>;
}

export function Levels({ ratings }: { ratings: Rating[] }) {
  return <div role="list">
    {ratings.map((r) => <div className="lvrow" role="listitem" key={r.skill} style={r.locked ? { opacity: 0.5 } : undefined}
      aria-label={r.locked ? `${r.name}, not unlocked yet` : `${r.name} level ${r.rating.toFixed(1)}`}>
      <span>{r.name}</span><Pips level={r.rating} /><span className="num">{r.locked ? "soon" : r.rating.toFixed(1)}</span>
    </div>)}
  </div>;
}
